import { Analytics } from './analytics'

export enum DocumentWorkspaceAnalyticsPropertyEvent {
   processName = 'Process name',
   documentName = 'Document name',
   isCustom = 'Is custom',
   sharedVia = 'Shared via'
}

export enum DocumentWorkspaceAnalyticsEvent {
   preworkSent = 'Pre-work sent',
   feedbackSent = 'Feedback sent',
   preworkReceived = 'Pre-work received',
   feedbackReceived = 'Feedback received',
   documentFinalised = 'Document finalised',
}

namespace DocumentWorkspaceAnalyticsParams {
   export type PreworkSent = {
      processName: string,
      documentName: string,
      isCustom: boolean,
      sharedVia: 'Email' | 'Link'
   }

   export type FeedbackSent = {
      processName: string,
      documentName: string,
      isCustom: boolean,
      sharedVia: 'Email' | 'Link'
   }

   export type PreworkReceived = {
      processName: string,
   }

   export type FeedbackReceived = {
      processName: string,
   }

   export type DocumentFinalised = {
      processName: string,
      documentName: string,
      isCustom: boolean,
   }
}

export default class DocumentWorkspaceAnalytics implements Analytics {
   static preworkSent = (params: DocumentWorkspaceAnalyticsParams.PreworkSent) => {
      return Analytics.emitEvent(DocumentWorkspaceAnalyticsEvent.preworkSent, {
         processName: params.processName,
         documentName: params.documentName,
         isCustom: params.isCustom,
         sharedVia: params.sharedVia,
      })
   }

   static feedbackSent = (params: DocumentWorkspaceAnalyticsParams.FeedbackSent) => {
      return Analytics.emitEvent(DocumentWorkspaceAnalyticsEvent.feedbackSent, {
         processName: params.processName,
         documentName: params.documentName,
         isCustom: params.isCustom,
         sharedVia: params.sharedVia,
      })
   }

   static preworkReceived = (params: DocumentWorkspaceAnalyticsParams.PreworkReceived) => {
      return Analytics.emitEvent(DocumentWorkspaceAnalyticsEvent.preworkReceived, {
         processName: params.processName,
      })
   }

   static feedbackReceived = (params: DocumentWorkspaceAnalyticsParams.FeedbackReceived) => {
      return Analytics.emitEvent(DocumentWorkspaceAnalyticsEvent.feedbackReceived, {
         processName: params.processName,
      })
   }

   static documentFinalised = (params: DocumentWorkspaceAnalyticsParams.DocumentFinalised) => {
      return Analytics.emitEvent(DocumentWorkspaceAnalyticsEvent.documentFinalised, {
         "Process name": params.processName,
         "Document name": params.documentName,
         "Is custom": params.isCustom,
      })
   }
}
